<template>
  <div class="card assets-create">
    <header class="card-header has-background-dark">
      <p class="card-header-title has-text-light">CREATE ASSET</p>
    </header>
    <div class="card-content">
      <base-select :service="codeService" fetch-func="all" :fetch-params="{ type : 'ASSET'}" label="ASSET TYPE" :horizontal="true" @input="val => form.codeId = val">
        <template v-slot:defaultOptionLabel>Please Select</template>
      </base-select>
      <b-field label="SAP ID" horizontal>
        <b-input v-model="form.thirdPartyCode"></b-input>
      </b-field>
    </div>
    <footer class="card-footer">
      <a class="card-footer-item" href="#" @click.prevent="$emit('cancel')">CANCEL</a>
      <a class="card-footer-item" href="#" @click.prevent="save">
        {{ saving ? "SAVING..." : "SAVE" }}
      </a>
    </footer>
  </div>
</template>

<script>
import BaseSelect from "@/components/partials/BaseSelect";
import { AssetService } from "@/services/asset.service.js";
import { CodeService } from "@/services/code.service.js";

export default {
  props: {
    nodes: {
      type: Array,
      default: () => []
    }
  },
  components: {
    BaseSelect
  },
  data: () => ({
    codeService: CodeService,
    form: {
      codeId: "",
      thirdPartyCode: ""
    },
    saving: false
  }),
  methods: {
    save() {
      if (this.nodes.length > 0) {
        const request = {
          ...this.form,
          assetNodes: this.nodes
        };

        this.saving = true;

        AssetService.create(request).then(
          response => {
            this.$emit("save-success");
            this.saving = false;
          },
          error => {
            this.saving = false;
          }
        );
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Assets/list/partials/form.vue